// Copy text to the clipboard, returning whether it succeeded.
//
// The async Clipboard API (navigator.clipboard) only exists in a SECURE context
// (https / localhost). The operator tablets run the dashboard over insecure
// http, where navigator.clipboard is simply ABSENT - so we fall back to the
// legacy execCommand('copy') path, which still works when called inside a user
// gesture (the tap that triggered the copy). Callers show a manual-copy dialog
// only when BOTH paths fail.
function legacyCopy(text: string): boolean {
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    // Keep it off-screen and non-disruptive, but still selectable.
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '-9999px';
    ta.setAttribute('readonly', '');
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Secure-context API present but denied/failed - fall through to legacy.
  }
  return legacyCopy(text);
}
